<template>
  <div>
    <!-- 主轮播 -->
    <hero-carousel :commonData="commonData" />
    <!-- 数据产品 -->
    <Products :data="productsData" />
    <!-- 场景化方案 -->
    <Solutions :data="solutionsData" />
  </div>
</template>

<script>
import HeroCarousel from "./components/hero-carousel.vue";
import Products from "./components/products/index.vue";
import Solutions from "./components/solutions/index.vue";
import { cloneDeep } from "lodash";
export default {
  name: "Home",
  components: {
    HeroCarousel,
    Products,
    Solutions
  },
  props: {
    commonData: Object
  },
  computed: {
    productsData() {
      return cloneDeep(this.commonData.productsData);
    },
    solutionsData() {
      return cloneDeep(this.commonData.solutionsData);
    }
  }
};
</script>
